import moduleName from './main.module';
import './_services/i18n_options.provider.js';
import './_services/locale.service.js';
import './_services/runtime_translate.provider.js';
import './_translations/en.js';
import './entry.module.js';
import './language-picker/language_picker.directive.js';
import './main.config.js';
import './main.module.js';
import './main.run.js';
import './time-zone/custom_time_zones.constant.js';
import './time-zone/time_zone_options.service.js';
import './time-zone/time_zone_override.provider.js';
import './time-zone/time_zone_select.component.js';
import './time-zone/time_zone_utils.service.js';
import './time-zone/time_zone.service.js';
export default moduleName;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-i18n/entry.module.js